// CreatePlacement payload builders – extracted from CreatePlacementOrPackageService
import { PlacementDetailsTableService, PlacementUtils } from '../';
import { Utils } from "../../../shared";
import { assignParameterValueToChildPlacementUpdatePayload, getPackageType } from './createPlacement-utils';

export const prepareCreatePlacementPayload = (formData, omniProfile, packageType = "Standalone", programmaticParentId, selectedItems, taxonomyFields = null) => {
  const payload = [{
    "packageType": packageType,
    "placementCost": {
      "unitAmount": (formData['Unit Amount'] || formData['Unit Amount'] === 0) ? formData['Unit Amount'] : 0,
      "plannedCost": { "amount": (formData['Planned Cost'] || formData['Planned Cost'] === 0) ? Number(formData['Planned Cost']) : 0 },
      "rate": { "amount": (formData['Rate'] || formData['Rate'] === 0) ? Number(formData['Rate']) : 0 }
    },
    "placementNumber": null,
    "placementTaxonomy": formData['Placement Name'],
    "placementTaxonomyDisplay": formData['Placement Display Name'],
    "overridenPlacementTaxonomy": formData['Override Placement Name'],
    "overridenPlacementTaxonomyDisplay": formData['Override Placement Display Name'],
    "taxonomySchema": formData['Placement Schema'],
    "placementType": !formData['Parameter Code Buy Type'] || formData['Parameter Code Buy Type'] == 'NU' ? '' : formData['Parameter Code Buy Type'],
    "buyCategory": formData['Parameter Code Buy Category'],
    "unitType": formData['Parameter Code Unit Type'],
    "costMethod": formData['costMethod'],
    "site": !formData['Parameter Code Site'] || formData['Parameter Code Site'] == 'NU' ? '' : formData['Parameter Code Site'],
    "supplierCode": formData['supplierCode'],
    "supplier": formData['supplier'] || formData['Parameter Code Supplier'],
    "dimensionsPosition": formData['Parameter Code Dimension/Positions'],
    "dimensions": formData['Parameter Code Dimensions'],
    "flightStart": PlacementDetailsTableService.converDateToYMDFormat(formData['Flight Start']),
    "flightEnd": PlacementDetailsTableService.converDateToYMDFormat(formData['Flight End']),
    "servedBy": formData['Parameter Code Served By'],
    "createdBy": omniProfile?.email,
    "data_source": '',
    "primaryPlacement": false,
    "marketValue": "",
    "provider": !formData['Parameter Code Site'] || formData['Parameter Code Site'] == 'NU' ? '' : formData['Parameter Code Site'],
    "overrideTaxonomy": formData["isOverride"],
    "parameterCode": formData["Parameter Code"],
    "parameterCodeTaxonomyDisplay": formData["Parameter Code Display Name"],
    "parameterCodeTaxonomySchema": formData["Parameter Code Schema"],
    "parentId": programmaticParentId,
    "ad_verification": formData['Parameter Code Ad Verification'],
    "ad_server": formData['Parameter Code Ad Server'],
    "is_ad_server_fee_override": formData['overrideAdservingFees'],
    "is_ad_verification_fee_override": formData['overrideAdverificationFees'],
    "cpcCalcType": formData['CPC Calculation Type'],
    "billable": formData['billable'] ? formData['billable'] : null,
    "billableRate": formData['billableRate'] ? formData['billableRate'] : null,
    "margin": formData['margin'] ? formData['margin'] : null,
    "marginPercentage": formData['markupPercent'] ? formData['markupPercent'] : null,
    "tierId": formData['TierId'] ? formData['TierId'] : null,
    "taxonomy": formData['taxonomy'] ? formData['taxonomy'] : null,
    'taxonomy_client_id': formData.taxonomy_client_id,
    'taxonomy_schema_id': formData.taxonomy_schema_id
  }];

  if (!formData['overrideAdservingFees']) {
    payload[0]['ad_server_fee'] = null;
  } else if (formData['overrideAdservingFees']) {
    if (Number(formData['adserverfee'])) {
      payload[0]['ad_server_fee'] = Number(formData['adserverfee']);
    } else {
      payload[0]['ad_server_fee'] = null;
    }
  }

  if (!formData['overrideAdverificationFees']) {
    payload[0]['ad_verification_fee'] = null;
  } else if (formData['overrideAdverificationFees']) {
    if (Number(formData['adverificationfee'])) {
      payload[0]['ad_verification_fee'] = Number(formData['adverificationfee']);
    } else {
      payload[0]['ad_verification_fee'] = null;
    }
  }

  if (selectedItems?.length) {
    const packageCount = selectedItems.filter((pkg) => pkg.package_type === "Package").length;
    const childCount = selectedItems.filter((pkg) => pkg.package_type === "Child").length;
    const standaloneCount = selectedItems.filter((pkg) => pkg.package_type === "Standalone").length;

    if (packageCount === 1 && childCount >= 0 && (childCount + packageCount === selectedItems.length) && packageType !== "DirectCreative") {
      payload[0].parentId = selectedItems[0]?.id;
      payload[0].packageType = "Child";
    }

    if (packageType === "DirectCreative" && childCount === 1) {
      payload[0].parentId = selectedItems.find((pkg) => pkg.package_type === "Child")?.id;
    }

    if (packageType === "DirectCreative" && standaloneCount === 1 && packageCount === 0 && childCount === 0) {
      payload[0].parentId = selectedItems.find((pkg) => pkg.package_type === "Standalone")?.id;
    }
  }

  return payload;
};

export const applyTextCaseTransformation = (placementPayload, taxonomyFields) => {
  if (!taxonomyFields?.taxonomyTextcase) return;
  if (placementPayload.placementTaxonomy) {
    placementPayload.placementTaxonomy = PlacementUtils.transformValueToGivenCase(placementPayload.placementTaxonomy, taxonomyFields.taxonomyTextcase);
  }
  if (placementPayload.placementTaxonomyDisplay) {
    placementPayload.placementTaxonomyDisplay = PlacementUtils.transformValueToGivenCase(placementPayload.placementTaxonomyDisplay, taxonomyFields.taxonomyTextcase);
  }
  if (placementPayload.overridenPlacementTaxonomy) {
    placementPayload.overridenPlacementTaxonomy = PlacementUtils.transformValueToGivenCase(placementPayload.overridenPlacementTaxonomy, taxonomyFields.taxonomyTextcase);
  }
  if (placementPayload.overridenPlacementTaxonomyDisplay) {
    placementPayload.overridenPlacementTaxonomyDisplay = PlacementUtils.transformValueToGivenCase(placementPayload.overridenPlacementTaxonomyDisplay, taxonomyFields.taxonomyTextcase);
  }
  if (placementPayload.childLineItems && Array.isArray(placementPayload.childLineItems)) {
    placementPayload.childLineItems.forEach(childItem => {
      applyTextCaseTransformation(childItem, taxonomyFields);
    });
  }
};

export const assignPayloadValues = (placement, state) => {
  let payload = {
    "placementType": placement.placement_type,
    "buyCategory": placement.buy_category,
    "dimensions": placement.dimensions,
    "dimensionsPosition": placement?.dimension_positions || placement.dimensions_position,
    "servedBy": placement.served_by,
    "unitType": placement.unit_type,
    "costMethod": placement.cost_method,
    "site": placement.site,
    "provider": placement.provider,
    "id": placement.id
  };
  return {
    "is_currency_local": state.systemParametersData.data.isCurrencyLocal,
    "campaign_netmedia": state.campaignObj?.campaign_channel_total_budget,
    "campaign_netmedia_local": state.campaignObj?.campaign_channel_total_budget_local,
    "clientId": Utils.getRouteParam("clientid"),
    "placementTaxonomy": placement["placement_taxonomy"],
    "placementTaxonomyDisplay": placement["placement_taxonomy_display"],
    "overridenPlacementTaxonomy": placement["overriden_placement_taxonomy"] ? placement["overriden_placement_taxonomy"] : null,
    "overridenPlacementDisplayTaxonomy": placement["overriden_placement_display_taxonomy"] ? placement["overriden_placement_display_taxonomy"] : null,
    "taxonomySchema": placement["taxonomy_schema"],
    "parameterCode": placement["parameter_code"],
    "parameterCodeTaxonomyDisplay": placement["parameter_code_taxonomy_display"],
    "parameterCodeTaxonomySchema": placement["parameter_code_taxonomy_schema"],
    "placementType": placement['placement_type'],
    "taxonomy": placement['taxonomy'],
    "updated_by": state?.omniProfile && state.omniProfile['email'],
    'taxonomy_client_id': placement.taxonomy_client_id,
    'taxonomy_schema_id': placement.taxonomy_schema_id,
    ...payload,
  };
};

export const preparePayloadForPlacmentsUpdate = (placement, state) => {
  let schemaPayload = assignPayloadValues(placement, state);
  let childPayload = [];
  if (state?.childPlacmentsArray.length) {
    state.childPlacmentsArray.forEach(item => {
      let payload = assignPayloadValues(item, state);
      childPayload.push(payload);
    });
    schemaPayload = {
      childLineItems: [...childPayload],
      ...schemaPayload
    };
  }
  return schemaPayload;
};

export const prepareCreatePackagePayload = (formData, omniProfile, selectedPlacements, packageType = "Package", taxonomyFields = null) => {
  return new Promise(function (resolve, reject) {
    const packageData = prepareCreatePlacementPayload(formData, omniProfile, packageType, null, selectedPlacements, taxonomyFields);
    delete packageData[0]['servedBy'];
    packageData[0]['exportStatus'] = "Not Exported";
    packageData[0]['childLineItems'] = [];
    packageData[0]['packageType'] = packageType;
    if (selectedPlacements.length > 0) {
      selectedPlacements.forEach((placement, placementindex) => {
        packageData[0]['childLineItems'].push(createSelectedPlacementAsChildLineItems(placement));
        if (placementindex === selectedPlacements.length - 1) {
          resolve(packageData);
        }
      });
    } else {
      resolve(packageData);
    }
  });
};

export const createSelectedPlacementAsChildLineItems = (placement) => {
  return {
    "id": placement.id,
    "packageType": "Child"
  };
};

export const assignParameterValueToChildPlacement = (parentPayload, ChildrenPayload, defaultTaxonomyData, taxonomyFields = null) => {
  let childItemsPayload = [];
  ChildrenPayload.forEach(val => {
    let payload = val;
    if (!val['isDelete'] && !val['creative_id']) {
      if (parentPayload?.is_ad_server_fee_override) {
        val['is_ad_server_fee_override'] = true;
      }
      if (parentPayload?.is_ad_verification_fee_override) {
        val['is_ad_verification_fee_override'] = true;
      }
      defaultTaxonomyData?.fields.forEach(val => {
        let name = val.name.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
          return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, '');
        name = name.replace(/[^A-Z0-9]+/ig, "");
        payload = assignParameterValueToChildPlacementUpdatePayload(payload, parentPayload, name);
      });
      if (payload['childLineItems'] && payload.childLineItems.length) {
        payload['childLineItems'] = assignParameterValueToChildPlacement(parentPayload, val.childLineItems, defaultTaxonomyData, taxonomyFields);
      }
    }
    let taxonomy = payload['taxonomy']?.map((item) => {
      delete item['field_name'];
      delete item['name'];
      delete item['hidden'];
      return item;
    });
    payload['taxonomy'] = taxonomy;
    childItemsPayload.push(payload);
  });
  return childItemsPayload;
};

export const createPackageChildItemsPayload = (placementList, omniProfile, isEdit, taxonomyFields = null) => {
  let placementChildPayloads = [];
  if (placementList && placementList.length) {
    placementList.forEach((items) => {
      let payload = prepareCreatePlacementPayload(items, omniProfile, 'Standalone', null, [], taxonomyFields)[0];
      delete payload['servedBy'];
      payload['exportStatus'] = "Not Exported";
      let id = Number(items.id);
      if (isEdit && id) {
        payload['id'] = id;
      }
      if (items?.nestedData?.length) {
        payload['childLineItems'] = createPackageChildItemsPayload(items.nestedData, omniProfile, isEdit, taxonomyFields);
      } else {
        payload['childLineItems'] = [];
      }
      payload['packageType'] = getPackageType(items.programmaticType);
      payload['creative_id'] = items.creative_id;
      placementChildPayloads.push(payload);
    });
  }
  return placementChildPayloads;
};
